import { useState } from 'react';
import { FieldValues } from 'react-hook-form';
import { ICandidate, importToVMS } from 'wisestep-api';

import { success, failed } from '../../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../../utils/NotificationStore';

import MandatoryVMSFields from './MandatoryVMSFields';
import ViewVMSDetails from './ViewVMSDetails';

const SAPFieldGlassUpload = ({ candidate }: { candidate: ICandidate }) => {
  const [isCandidateVerified, setIsCandidateVerified] = useState(false);
  const [candidateEntity, setCandidateEntity] = useState<ICandidate>(candidate);
  const [isDisabled, setIsDisabled] = useState(false);
  const setNotification = useNotificationStore((state) => state.setNotification);

  const handleMandatoryFieldsSubmit = async (data: FieldValues) => {
    if (candidateEntity) {
      try {
        setIsDisabled(true);
        candidateEntity.vmsSource = ['SAPfieldglass'];
        candidateEntity.ssnNumber = data.ssnNumber;
        candidateEntity.availableFrom = data.availableFrom;
        candidateEntity.assessment = data.comment;
        candidateEntity.dob = data.dob;
        const req = await importToVMS(candidateEntity);
        if (req.data === 'SUCCESS') {
          setNotification(success('Candidate Submitted to VMS Succesfully'));
          setTimeout(() => window.location.reload, 400);
        } else {
          setIsCandidateVerified(false);
          setIsDisabled(false);
          setNotification(failed('Something went wrong. Please try later'));
        }
      } catch (e) {
        setIsCandidateVerified(false);
        setIsDisabled(false);
        setNotification(failed('Something went wrong. Please try later'));
      }
    }
  };

  return (
    <>
      {!isCandidateVerified && (
        <ViewVMSDetails
          candidateDetail={candidate}
          afterReview={(data) => {
            setCandidateEntity(data);
            setIsCandidateVerified(true);
          }}
        />
      )}
      {isCandidateVerified && (
        <MandatoryVMSFields
          candidate={candidateEntity}
          onSubmit={handleMandatoryFieldsSubmit}
          isDisabled={isDisabled}
          navigateBack={() => setIsCandidateVerified(false)}
        />
      )}
    </>
  );
};

export default SAPFieldGlassUpload;
